import { useQuery } from '@apollo/client';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { GridContainer, GridItem } from '@xing-com/grid';
import { Section } from '@xing-com/layout-primitives';
import { spaceXXL, spaceXL, spaceXS } from '@xing-com/tokens';
import { Meta, Headline } from '@xing-com/typography';

import { GetNetworkTopRecruitersDocument } from '../../graphql/get-network-top-recruiters.gql-types';

import { HeroCarousel } from './hero-carousel';

const StyledHeadline = styled(Headline)`
  padding-top: ${spaceXL};
  margin-bottom: ${spaceXS};
`;

const StyledMeta = styled(Meta)`
  margin-bottom: ${spaceXXL};
`;

export const TopRecruiters: React.FC = () => {
  const isRandomized = React.useRef(false);

  const { data, error } = useQuery(GetNetworkTopRecruitersDocument, {
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    nextFetchPolicy: 'cache-first',
    errorPolicy: 'all',
  });

  const [randomizedData, setRandomizedData] = React.useState(
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    [] as any
  );

  const showSection =
    !error &&
    data !== undefined &&
    (data?.networkTopRecruiters?.collection?.length ?? 0) > 0;

  React.useEffect(() => {
    if (!isRandomized.current && data?.networkTopRecruiters?.collection) {
      setRandomizedData(
        data?.networkTopRecruiters?.collection
          ?.map((value) => value)
          .sort(() => Math.random() - 0.5) || []
      );

      if (randomizedData?.length) {
        isRandomized.current = true;
      }
    }
  }, [data?.networkTopRecruiters?.collection, randomizedData?.length]);

  if (!showSection) {
    return null;
  }

  return (
    <Section data-qa="top-recruiters">
      <GridContainer variant="expanded">
        <GridItem>
          <StyledHeadline size="xxlarge" sizeConfined="xxxlarge">
            <FormattedMessage id="NETWORK_LOGGED_OUT_TOP_RECRUITERS_HEADLINE" />
          </StyledHeadline>
          <StyledMeta size="medium" sizeConfined="large">
            <FormattedMessage id="NETWORK_LOGGED_OUT_TOP_RECRUITERS_SUBLINE" />
          </StyledMeta>
          <HeroCarousel items={randomizedData} />
        </GridItem>
      </GridContainer>
    </Section>
  );
};
